import { PaginationControl } from '@virtidev/toolbox';

export { PaginationControl };

export default PaginationControl;
